/* unplugin-vue-components disabled */import { render } from "./DownPage.vue?vue&type=template&id=743ca6bd&scoped=true"
import script from "./DownPage.vue?vue&type=script&lang=js"
export * from "./DownPage.vue?vue&type=script&lang=js"

import "./DownPage.vue?vue&type=style&index=0&id=743ca6bd&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-743ca6bd"]])

export default __exports__